// extracted by mini-css-extract-plugin
export default {"bg_image_container":"SplashScreen_bg_image_container__Ew5UO"};